import React from "react";
import { Spin } from "antd";

const Loading = () => {
  return (
    <div className="fw-loading">
      <Spin size="large" />
    </div>
  );
};

export default Loading;
